import { pgEnum } from "drizzle-orm/pg-core";
import { foodTypes } from "./constants";

export const foodType = pgEnum("food_type", foodTypes);
